<div class="flex" style="height: 100%">
	<div class="flex-direction-row flex-align-center" style="height: 100%">
		<div class="flex-30"></div>
		<div class="flex flex-direction-column flex-align-center">
			<div class="flex-30"></div>
			<div class="flex">
				<img src="../assets/startPage.png" class="image" />
			</div>
			<div class="flex-30"></div>
		</div>
		<div class="flex-30"></div>
	</div>
</div>
